<template>
  <div>

    <div>
      <el-dialog title="购物车" :visible.sync="dialogTableVisible" :before-close="carDialogClose">
        <div class="shopping_car_box">
          <div class="shopping_car_list">
            <div class="one_shopping_list" v-for="(item,index) in carList" :key="index" v-if="item.num>0">
              <div class="one_shopping_left">
                <div class="shopping_image_box">
                  <img :src="item.image" style="width: 100%;height: auto" alt=""/>
                </div>
                <div class="shopping_word_box">
                  <span style="display: block;font-size: 1rem;font-weight: bold;padding: 0.5rem 0 1rem 0.5rem">{{item.name}}</span>
                  <el-input-number v-model="item.num" @change="handleChange" :min="0" :max="10" label="数量" v-if="item.num>0"></el-input-number>
                </div>
              </div>
              <div class="one_shopping_right">
                <span>￥{{towNumber(item.price * item.num)}}</span>
              </div>
            </div>
          </div>
          <div class="shopping_money_box">
            <div style="width: 20%;height: 7rem;">
              <div style="padding: 0.5rem">
                <span style="font-size: 1.2rem;color: black">合计：</span>
                <span style="font-size: 1.2rem;color: rgb(221,195,70);">￥{{towNumber(allMoney)}}</span>
              </div>
              <button style="width:8rem;height: 2.5rem;border: none;color: white;background-color: rgb(221,195,70);margin: 1rem auto;display: block" @click="payMoney">结算</button>
            </div>
          </div>
        </div>
      </el-dialog>

    </div>
    <div>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="40%"
       >
        <span style="display: block;padding: 1rem 0;font-size: 1.2rem;width: 100%;text-align: center"> 请联系客服确认商品信息后再付款   电话：15160001564   qq：920209695</span>
        <img src="../../assets/image/index/weChatPay.jpg" style="width:70%;height: auto;margin: 0 auto;display: flex"/>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="closeDialog">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>

</template>

<script>
    export default {
        name: "shoppingCar",

      data(){
          return{
            val:1,
            carList:[],
            allMoney:0,
            dialogVisible:false,
            allCount:0
          }
      },
      props:{
       dialogTableVisible:{
         type:Boolean
       }
      },
      // created() {
      //   let that=this;
      //   let carList=sessionStorage.getItem('shoppingCarList');
      //   if(carList!==undefined && carList!==null){
      //     that.carList=JSON.parse(carList);
      //   }else{
      //     that.carList=[];
      //   }
      //   that.allMoney=0;
      //   for(let i=0;i<=that.carList.length-1;i++){
      //     that.allMoney+=that.carList[i].num*that.carList[i].price;
      //   }
      // },
      mounted() {
          let that=this;
          that.getList();
      },
      methods:{
        towNumber(val) {
          return val.toFixed(2)
        },
          getList(){
            let that=this;
            let carList=sessionStorage.getItem('shoppingCarList');
            if(carList!==undefined && carList!==null){
              that.carList=JSON.parse(carList);
            }else{
              that.carList=[];
            }
            that.allMoney=0;
            for(let i=0;i<=that.carList.length-1;i++){
              that.allMoney+=that.carList[i].num*that.carList[i].price;
            }
          },
        handleChange(val){
          let that=this;
          that.allMoney=0;
          for(let i=0;i<=that.carList.length-1;i++){
            that.allMoney+=that.carList[i].num*that.carList[i].price;
          }
          if(that.allMoney===0){
            //   that.carList.splice(i,1);
            that.carDialogClose();
          }
        },
        payMoney(){
          let that=this;
          that.dialogVisible=true;
        },
        closeDialog(){
          let that=this;
          sessionStorage.removeItem("shoppingCarList");
          sessionStorage.removeItem("allCount");
          that.dialogVisible=false;
          this.$emit("carDialogClose",false);
        },
        carDialogClose(){
          console.log('carDialogClose');
          console.log(this.carList);
            let that=this;
            that.allCount=0
            for(let i=0 ; i <= that.carList.length-1 ; i++){
              that.allCount += that.carList[i].num;
            }
            that.carList=that.carList.filter(function(item){
              return item.num!==0;
            })
            if(that.allCount===0&&that.carList===[]){
              console.log('购物车已经没有东西啦~')
              sessionStorage.removeItem("shoppingCarList");
              sessionStorage.removeItem("allCount");
              return false;
            }
          sessionStorage.removeItem("shoppingCarList");
          sessionStorage.removeItem("allCount");
          sessionStorage.setItem('shoppingCarList',JSON.stringify(that.carList));
          sessionStorage.setItem('allCount',that.allCount);
          this.$emit("carDialogClose",false)
        }
      },
      watch:{
        dialogTableVisible(newVal,oldVal){
          let that=this;
          that.getList();
        }
      }
    }
</script>

<style scoped>
.shopping_car_box{
  width: 100%;
  height: 40rem;
}
  .shopping_car_list{
    width: 100%;
    height: 30rem;
    overflow-y: auto;
    padding: 1rem 0;
  }
  .one_shopping_list{
    width: 96%;
    height: 11rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid  rgb(226,228,231);;
  }
  .one_shopping_left{
    width: 38%;
    height: 11rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .one_shopping_right{
    width: 20%;
    height: 11rem;
    text-align: center;
    line-height: 11rem;
    color: rgb(221,195,70);
  }
  .shopping_image_box{
    width: 40%;
    height: 6rem;
  }
  .shopping_word_box{
    width: 55%;
    height: 6rem;
  }
  .shopping_money_box{
    width: 100%;
    height: 7rem;
    display: flex;
    justify-content: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/shoppingCar.vue